<template>
  <div id="app">
    <router-view />    
  </div>
</template>

<script>
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  import '@mysummar/summar-vue/src/assets/css/colors.css'
  import '@mysummar/summar-vue/src/assets/css/font-comfortaa.css' 
  import './assets/css/fabric-icons.css'
  import '@mysummar/summar-vue/src/assets/css/theme.css' 
  import './assets/scss/theme-vue.scss'
  import '@mysummar/summar-vue/src/assets/css/summar-font.css' 
  import '@mysummar/summar-vue/src/assets/css/mm-tabla.css'

  export default {
    name: 'App',
    beforeCreate() {
      document.getElementsByTagName('body')[0].className = 'theme-blue';
    }
  }
</script>
